import { memo, useEffect, useRef, useState } from "react";

import { Textfield } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { DEBOUNCE_TIME } from "../constants";
import { USED, ENTER_CUSTOM_NAME, PLACEHOLDER } from "../texts";

import { collisionItemKeys } from "./dataAutomation";
import * as SC from "./styles";

type ItemSchema = {
    text: string;
    index: number;
    isError: boolean;
    errorMessage?: string;
    debounceMs?: number;
    onDebouncedChange: (index: number, value: string) => void;
};

const Item = ({ index, text, onDebouncedChange, isError, errorMessage, debounceMs = DEBOUNCE_TIME }: ItemSchema) => {
    const [value, setValue] = useState("");
    const timerRef = useRef<number | null>(null);

    useEffect(() => {
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
        }

        timerRef.current = window.setTimeout(() => onDebouncedChange(index, value), debounceMs);

        return () => {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
            }
        };
    }, [index, value, onDebouncedChange, debounceMs]);

    return (
        <SC.ItemContainer data-automation={collisionItemKeys.container}>
            <SC.Used data-automation={collisionItemKeys.title}>
                <SC.TopicName>{text}</SC.TopicName>
                {translate(USED)}
            </SC.Used>

            <SC.InputWrapper data-automation={collisionItemKeys.input}>
                <Textfield
                    label={translate(ENTER_CUSTOM_NAME)}
                    error={isError}
                    placeholder={translate(PLACEHOLDER)}
                    onChange={(t) => setValue(t)}
                    errorMessage={isError ? errorMessage : undefined}
                />
            </SC.InputWrapper>
        </SC.ItemContainer>
    );
};

export default memo(Item);
